const config = {
  GRAPHQL_URL:
    process.env.NEXT_PUBLIC_GRAPHQL_URL ||
    "https://graphql.ceedow.world/graphql",
  REST_API:
    process.env.NEXT_PUBLIC_GRAPHQL_URL || "https://graphql.ceedow.world",
  GRAPHQL_WS_URL:
    process.env.NEXT_PUBLIC_GRAPHQL_WS_URL ||
    "wss://graphql.ceedow.world/graphql",
  GRAPHQL_PAIMENT: "https://graphql.ceedow.world/paimentpro/webhook",
  FRONTEND_URL: "https://ceedow.world",
  env: process.env.NEXT_PUBLIC_ENV || "production",
  encrypt: {
    secret: process.env.NEXT_ENCRPT_SECRET || "code12345",
  },
  clientIdGoogle:
    "103070263161-3oi49l64b9ca224ilkuk5lprockbc3pa.apps.googleusercontent.com",
  stripe: {
    stripePublishableKey: process.env.STRIPE_PUBLISHABLE_KEY,
  },
  // paypal: {
  //   paypalClientId:
  //     process.env.NEXT_APP_PAYPAL_CLIENT_ID,
  // },
  firebase: {
    apiKey: "AIzaSyC90_-wdTZ_ARZ-qL0EuIRTpv9fVf9QCZ0",
    authDomain: "ceedow-5b718.firebaseapp.com",
    projectId: "ceedow-5b718",
    storageBucket: "ceedow-5b718.appspot.com",
    messagingSenderId: "365702570752",
    appId: "1:365702570752:web:f14c9b2eb365cbe428c9e5",
    measurementId: "G-9E8HM1960S",
  },
  isOnDev: false,
  nofitication: {
    vapidKey: "test",
  },
};
export default config;
